import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './locales/en/common.json';
import frCommon from './locales/fr/common.json';

export const LANG_STORAGE_KEY = 'app_language_v2';

// Default language is French. Prefer an explicit saved choice when present.
const savedLang = localStorage.getItem(LANG_STORAGE_KEY);
const initialLang = savedLang === 'en' || savedLang === 'fr' ? savedLang : 'fr';
if (!savedLang) {
  localStorage.setItem(LANG_STORAGE_KEY, 'fr');
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      fr: { common: frCommon },
    },
    lng: initialLang,
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
